export class Fax {
  constructor({
    faxID = 0,
    orderID = 0,
    ratePlanId = 0,
    incomingEmail = null,
    outgoingEmail = [],
    numberType = null,
    city = null,
    faxNo = null,
    currentProvider = null,
    accountNo = null,
  } = {}) {
    this.faxID = faxID;
    this.orderID = orderID;
    this.ratePlanId = ratePlanId;
    this.incomingEmail = incomingEmail;
    this.outgoingEmail = outgoingEmail;
    this.numberType = numberType;
    this.city = city;
    this.faxNo = faxNo;
    this.currentProvider = currentProvider;
    this.accountNo = accountNo;
  }
}

export function CreateNewFax(data) {
  return Object.freeze(new Fax(data));
}
